import request from '@/utils/request'
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 查询优惠券列表
export function getCouponList (data) {
    return request({
        url: GateWay + '/coupon/query',
        method: 'post',
        data
    })
}
// 添加优惠券
export function insertCoupon (data) {
    return request({
        url: GateWay + '/coupon/insert',
        method: 'post',
        data
    })
}
// 查询优惠券数量
export function getCouponSize (data) {
    return request({
        url: GateWay + '/coupon/querySize',
        method: 'post',
        data
    })
}